import React from "react";
import PropTypes from "prop-types";
import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import FormSwitch from "./FormSwitch";
import { ControllerProps } from "react-hook-form";
import { Translation } from "../TranslationWrapper/TranslationWrapper";
import { SwitchProps } from "@mui/material";
import { FormProps } from "./FormProps";

function FormSwitchTC(
  props: FormProps & Translation & { rules?: ControllerProps["rules"] } & { fieldProps?: SwitchProps }
) {
  return (
    <FormFieldTwoColumns {...props} gridSizes={props.gridSizes ?? { column1: { xs: 4 }, column2: { xs: 8 } }}>
      <FormSwitch name={props.name} />
    </FormFieldTwoColumns>
  );
}

FormSwitchTC.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  label: PropTypes.oneOf([PropTypes.element, PropTypes.string]), // FormField props
};

export default FormSwitchTC;
